<template><div><h1 id="dimensionen-definieren" tabindex="-1"><a class="header-anchor" href="#dimensionen-definieren"><span>Dimensionen definieren</span></a></h1>
<p>Dimensionen definieren — Definiert die Dimensionen für die Mailingauswertung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Mailingauswertung ermöglich den schnellen und regelmässigen Export von Ereignisdaten.</p>
<p>Die Definition der Dimensionen legt fest, welche Auswertedimensionen für ein Ereignis zur verfügung stehen sollen und an welchen Datum (Stichtag) die einzelnen Dimensionen ausgewertet werden (typischerweise das Initialdatum des Ereignisses).</p>
<p>Hierbei handelt es sich um um die Definition der möglichen Dimensionen pro Ereignis. Die Zuordnung für die Auswertung wird unter <RouteLink to="/referenz/refs/ft.refdata.eamaildim.html" title="Dimensionen zuordnen">Dimensionen zuordnen</RouteLink> vorgenommen.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Mailingauswertung → Mailingauswertung Dimensionen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Ereignis</dt>
<dd>Die Nummer des <a class="link" href="ft.refdata.ereigkopf.html" title="Ereignisse">Ereignisses</a>, für das die Dimensionen berechnet werden. Nur eine Definition pro Ereignis ist möglich.</dd>
<dt>Bezeichnung</dt>
<dd>Die Bezeichnung des Ereignisses (nur Anzeige).</dd>
<dt>Stichtag</dt>
<dd>Das Datum, an dem der Adresszustand übernommen wird. Z.B. bei der Berechnung des Alters der Person wird das Alter an diesem Datum gerechnet. Dieses Datum hat nichts mit dem Auswertedatum zu tun. Typischerweise wird das das Initialdatum des Ereignisses eingesetzt.</dd>
<dt>Status</dt>
<dd>Der Status der Dimensionsvergabe. Die folgenden Stati sind möglich:
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>erfasst, löschbar. Die Dimensionen wurden noch nicht berechnet.</td>
</tr>
<tr>
<td>2</td>
<td>zurückgesetzt. Die Dimensionen wurden gelöscht.</td>
</tr>
<tr>
<td>5</td>
<td>berechnet. Die Dimensionen sind berechnet und auf den Ereignissen gespeichert.</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="dimensionen-berechnen" tabindex="-1"><a class="header-anchor" href="#dimensionen-berechnen"><span>Dimensionen berechnen</span></a></h3>
<p>Mit diesem Job werden die Dimenesionswerte pro Adresse definiert und in die Ereignisverknüpfungen geschrieben (für Benutzer nicht sichtbar).</p>
<h3 id="berechnung-zurucksetzen" tabindex="-1"><a class="header-anchor" href="#berechnung-zurucksetzen"><span>Berechnung zurücksetzen</span></a></h3>
<p>Mit diesem Job werden die Dimensionswerte aus den Ereignisverknüpfungen gelöscht (für Benutzer nicht sichtbar).</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tbldim.html" title="Dimension">Dimensionen</RouteLink></p>
</div></template>


